
export type TerminologiesActionTypes = UpdateTerminologiesAction;

export const UPDATE_TERMINOLOGIES = "UPDATE_TERMINOLOGIES";
export interface UpdateTerminologiesAction {
    type: typeof UPDATE_TERMINOLOGIES;
    terminologies: any;
}